import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { ContractInfoCard } from '../../components/contract-info-card.component';
import { YourContractsSection } from '../../components/your-contracts-section.component';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const blobURL = import.meta.env.VITE_API_IMAGE_URL;
const CreateTenderSwedish = `${blobURL}/StandardOffertInvozioIfyllningsbar.pdf`;
const CreateTender = `${blobURL}/Invoziotender.pdf`;
const WriteContractSwedish = `${blobURL}/KontraktInvozioIfyllningsbar.pdf`;
const WriteContract = `${blobURL}/InvozioContracts.pdf`;

function MyContractsPage() {
    const { t } = useTranslation();
    const language = new URLSearchParams(window.location.search).get('lang') || 'en';
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    function handleTenderAgreement() {
        if (language === 'sv-se') {
            window.open(CreateTenderSwedish)
        }
        else {
            window.open(CreateTender)
        }
    }
        function handleContractAgreement() {
        if (language === 'sv-se') {
            window.open(WriteContractSwedish)
        }
        else {
            window.open(WriteContract)
        }
    }


    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='contracts'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                {isSidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}

                <div className="dashboard-main-content">
                    <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                    />

                    <div className='px-3'>
                        <div style={{ marginTop: '24px' }}>
                            <div>
                                <ContractInfoCard />
                            </div>

                            <div style={{ marginTop: '24px' }}>
                                <YourContractsSection handleTenderAgreement={handleTenderAgreement} handleContractAgreement={handleContractAgreement} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default MyContractsPage;

